import { createTheme } from '@mui/material/styles';
import typography from './muiTypography';

export default createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#191919', // Cargill Black 90
      dark: '#000000', // Cargill Black
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#007582', // Cargill Light Blue 70 // for btns and text
      dark: '#005661', // Cargill Light Blue 80
      light: '#73B3BA',
      contrastText: '#000000',
    },
    error: {
      main: '#CD0D15',
      dark: '#BC080D', // progress bar indicator
      light: '#F5E1E2', // label background
    },
    success: {
      main: '#4F8B00', // progress bar indicator
      dark: '#466D0E', // forecast icon
      light: '#68A300', // progress bar
    },
    warning: {
      main: '#FFB110', // unused
      dark: '#FF9B00', // progress bar indicator
      light: '#FFFAD9', // label background
    },
    info: {
      main: '#0092CC',
      dark: '#0078A8',
      light: '#E6F1F3', // label background
    },
  },
  breakpoints: {
    values: {
      xs: 420,
      sm: 1440,
      md: 1600,
      lg: 1920,
    },
  },
  typography,
});
